<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select v-model="formData.range">
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="QUARTERLY">분기</option>
              </select>

              <!-- 일간 -->
              <DatePicker v-if="formData.range === 'DAILY'" :value="$utils.calcDate(null, '-1d')" class="blank" ref="picker" :maxDate="new Date()"/>
              <WeekPicker v-if="formData.range === 'WEEKLY'" class="blank" width="300px" ref="picker" :maxDate="new Date()"/>
              <MonthPicker v-if="formData.range === 'MONTHLY'" class="blank" ref="picker" :maxDate="new Date()"/>
              <QuarterPicker v-if="formData.range === 'QUARTERLY'" class="blank" ref="picker" :maxDate="new Date()"/>
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector
              permissionCode="statistic"
              :useGroup="false"
              ref="groupSelector"
              />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <template v-if="res">
      <h4 class="section_title"><span class="ico"></span>총 요청 건수</h4>

      <PlainTable :sourceList="totalTableItems">
        <template #header>
          <caption><span class="blind">통계 목록</span></caption>
          <colgroup>
            <col>
            <col width="33%">
            <col width="33%">
          </colgroup>

          <thead class="table_list_head table_list_head_line">
          <tr>
            <th></th>
            <th>요청건수</th>
            <th>대상자수</th>
          </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr>
            <td>{{rowData.name}}</td>
            <td class="right">{{rowData.requestCount}}</td>
            <td class="right">{{rowData.userCount}}</td>
          </tr>
        </template>
      </PlainTable>
    </template>

    <template v-if="res">
      <h4 class="section_title"><span class="ico"></span>콘텐츠별 조회수 순위 10</h4>

      <PlainTable :sourceList="topContentsList" :itemPerPage="10" :useExcel="true" ref="contentTable">
        <template #header>
          <caption><span class="blind">콘텐츠별 조회수 순위 10</span></caption>
          <colgroup>
            <col width="5%">
            <col>
            <col width="10%">
            <col width="10%">
            <col width="10%">
            <col width="10%">
            <col width="10%">
            <col width="10%">
          </colgroup>
          <thead class="table_list_head table_list_head_line">
            <tr>
              <th rowspan="2">순위</th>
              <th rowspan="2">제목</th>
              <th rowspan="2">추천정보 여부</th>
              <th rowspan="2">등록일</th>
              <th rowspan="2">마지막 조회일</th>
              <th colspan="3">조회수</th>
            </tr>
            <tr>
              <th>합계</th>
              <th>검색결과</th>
              <th>추천결과</th>
            </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr>
            <td>{{rowData.rank}}</td>
            <td>{{rowData.title}}</td>
            <td>{{rowData.recommended}}</td>
            <td>{{rowData.registeredDate}}</td>
            <td>{{rowData.lastAccessDate}}</td>
            <td class="right">{{rowData.totalCount}}</td>
            <td class="right">{{rowData.searchCount}}</td>
            <td class="right">{{rowData.recommendCount}}</td>
          </tr>
        </template>
      </PlainTable>
    </template>

    <template v-if="res">
      <h4 class="section_title"><span class="ico"></span>검색 키워드 순위 10</h4>

      <PlainTable :sourceList="keywordList" :itemPerPage="10" :useExcel="true" ref="keywordTable">
        <template #header>
          <caption><span class="blind">검색 키워드 순위 10</span></caption>
          <colgroup>
            <col width="10%">
            <col width="35%">
            <col width="10%">
            <col width="35%">
            <col width="10%">
          </colgroup>

          <thead class="table_list_head table_list_head_line">
          <tr>
            <th>순위</th>
            <th colspan="2">성공 키워드</th>
            <th colspan="2">실패 키워드</th>
          </tr>
          </thead>
        </template>
        <template #row="{rowData}">
          <tr>
            <td>{{rowData.rank}}</td>
            <td>{{rowData.successKeyword || '-'}}</td>
            <td :class="{right: rowData.successKeywordCount}">{{rowData.successKeywordCount || '-'}}</td>
            <td>{{rowData.failKeyword || '-'}}</td>
            <td :class="{right: rowData.failKeywordCount}">{{rowData.failKeywordCount || '-'}}</td>
          </tr>
        </template>
      </PlainTable>
    </template>

    <div class="section_button none_paginate">
      <button type="button" class="btn_excel" @click="onClickExcel"><span class="ico"></span>엑셀저장</button>
    </div>

  </section>
</template>

<script>
import XLSX from 'xlsx'
import mixin from './_mixin'

const resDefault = {
  contents: [],
  keywords: { fail: [], success: []},
  totalCount: { recommendation: {requestCount: 0, userCount: 0}, search: {requestCount: 0, userCount: 0}}
}

  export default {
    mixins: [ mixin ],
    data() {
      return {
        res: null,
        formData: {
          range: 'WEEKLY',
          state: '', city: '',
        }
      }
    },
    computed: {
      totalTableItems() {
        return [
          {
            name: '추천요청',
            requestCount: this.res.totalCount.recommendation.requestCount,
            userCount: this.res.totalCount.recommendation.userCount
          },
          {
            name: '검색 요청',
            requestCount: this.res.totalCount.search.requestCount,
            userCount: this.res.totalCount.search.userCount
          }
        ]
      },
      keywordList() {
        if(!this.res) return

        const data = []

        _.map(this.res.keywords.success, item => {
          const obj = {}
          obj.rank = item.rank
          obj.successKeyword = item.keyword
          obj.successKeywordCount = item.keywordCount
          data.push(obj)
        })

        _.forEach(this.res.keywords.fail, (item, index) => {
          if (data[index]) {
            if (item.rank === data[index].rank) {
              data[index].failKeyword = item.keyword
              data[index].failKeywordCount = item.keywordCount
            }
          } else {
            const obj = {}
            obj.rank = item.rank
            obj.failKeyword = item.keyword
            obj.failKeywordCount = item.keywordCount
            data.push(obj)
          }
        })

        return data
      },
      topContentsList() {
        if (!this.res) return
        return this.res.contents
      }
    },
    methods: {
      loadData() {
        const options = this.requestOptions()
        this.$axios.get('/admin/happy/stats/health', options).then(({data}) => this.res = _.merge({}, resDefault, data))
      },
      requestOptions() {
        const startDate = this.$refs.picker.getDate()
        const group = this.$refs.groupSelector.getData()

        return { params: _.merge(this.formData, {
          searchDate: this.$utils.dateformat(startDate, 'yyyy-mm-dd'),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId,
        })}
      },
      onClickExcel() {
        const wb = XLSX.utils.book_new()
        const contentsWS = XLSX.utils.table_to_sheet(this.$refs.contentTable.getExcelTable())
        const keywordsWS = XLSX.utils.table_to_sheet(this.$refs.keywordTable.getExcelTable())
        XLSX.utils.book_append_sheet(wb, contentsWS, '콘텐츠별 조회수 순위')
        XLSX.utils.book_append_sheet(wb, keywordsWS, '검색 키워드 순위')
        XLSX.writeFile(wb, `건강톡톡통계.xlsx`)
      }
    },
    mounted() {
      this.loadData()
    }
  }
</script>
